import React from "react";
import MyOutfitTabBarView from "presentational/portfolio/MyOutfitTabBarView";
import MyOutfitList from "container/portfolio/MyOutfitList";
import PickList from "container/portfolio/PickList";
import PropTypes from "prop-types";

MyOutfitGroup.propTypes = {
  value: PropTypes.oneOf(["mylist", "favorites", "bookmarked", "myitem"])
    .isRequired,
  onTabBtnClick: PropTypes.func.isRequired
};

function MyOutfitGroup(props) {
  const { value, onTabBtnClick } = props;

  return (
    <div>
      <MyOutfitTabBarView value={value} onTabBtnClick={onTabBtnClick} />
      <div>
        {value === "mylist" && <MyOutfitList />}
        {value === "favorites" && <PickList />}
      </div>
    </div>
  );
}

export default MyOutfitGroup;
